import { render, staticRenderFns } from "./OutPackage.vue?vue&type=template&id=10e33f02&scoped=true"
import script from "./OutPackage.vue?vue&type=script&lang=js"
export * from "./OutPackage.vue?vue&type=script&lang=js"
import style0 from "../../scss/grid.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./OutPackage.vue?vue&type=style&index=1&id=10e33f02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e33f02",
  null
  
)

export default component.exports